const create = (entity) => `${entity}:create`;
const modify = (entity) => `${entity}:modify`;
const modifyId = (entity, id) => `${entity}:modify:${id}`;
const read = {
    item: (entity, id) => [modifyId(entity, id)],
    collection: (entity) => [modify(entity), create(entity)],
};
const write = {
    create: (entity) => [create(entity)],
    modify: (entity, id) => [
        modify(entity),
        modifyId(entity, id),
    ],
};
export default {
    read,
    write,
};
// Collection/aggregation invalidation: Create | Update | Delete
// Item invalidate: Update x | Delete x
// On write
// Create
// - entity:create
// Update
// - entity:modify
// - entity:modify:id
// Delete
// - entity:modify
// - entity:modify:id
// On read
// Item
// - entity:modify:id
// Collection/Aggregation
// - entity:create
// - entity:modify
//
// TODO: What is a good way to say i'm a collection, but under a certain scope (ex. documents - invalidate if create or modify on case id)
//# sourceMappingURL=keys.js.map